import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import React from 'react'

type Props = {
  title: string
  link?: string
  onClick?: () => void
  bg?: string
  textColor?: string
  width?: string
  isDisabled?: boolean
  additionalCSS?: React.CSSProperties
}

export const PillButton = ({
  title,
  link,
  onClick,
  bg,
  textColor,
  width,
  additionalCSS,
  isDisabled = false,
}: Props) => {
  const commonProps = {
    bg,
    width,
    textColor,
    style: additionalCSS,
  }

  if (isDisabled) {
    return (
      <PillButtonContainer
        {...commonProps}
        style={{ ...additionalCSS, cursor: 'not-allowed', opacity: 0.6 }}
      >
        <PillArrow src="/icons/icon-arrow-right.svg" alt="arrow right" />
        <PillTitle>{title}</PillTitle>
      </PillButtonContainer>
    )
  }

  const ButtonContent = (
    <PillButtonContainer {...commonProps} onClick={onClick}>
      <PillArrow src="/icons/icon-arrow-right.svg" alt="arrow right" />
      <PillTitle>{title}</PillTitle>
    </PillButtonContainer>
  )

  if (link && link.startsWith('http')) {
    return (
      <NavLink to={link} target="_blank">
        {ButtonContent}
      </NavLink>
    )
  } else if (link && link.startsWith('/')) {
    return <NavLink to={link}>{ButtonContent}</NavLink>
  } else {
    return ButtonContent
  }
}

const PillTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease;
  transform: translateX(-17.5px);
`
const PillArrow = styled.img.attrs({ loading: 'lazy' })`
  width: 25px;
  height: 25px;
  transition: all 0.3s ease;
  opacity: 0;
`
const PillButtonContainer = styled.div<{
  bg?: string
  width?: string
  textColor?: string
}>`
  width: ${({ width }) => width || 'auto'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 32px;
  font-weight: bold;
  border-radius: 9999px;
  background-color: ${({ bg, theme }) => bg || theme.colors['gray-500']};
  color: ${({ textColor }) => textColor || 'white'};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    ${PillTitle} {
      transform: translateX(5px);
    }
    ${PillArrow} {
      filter: ${({ bg }) =>
        bg === 'white'
          ? 'brightness(0) saturate(100%)'
          : 'invert(89%) sepia(100%) saturate(0%) hue-rotate(72deg) brightness(109%) contrast(101%)'};
      opacity: 1;
    }
  }
`
